export default "__VITE_ASSET__CL3NqhVU__"